// @flow

import { onlyWhenSupport, type UserInputValidationError, type UserInputValidatorArgs, VALID} from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { validateElSalvadorianDocument } from '@tectonics/prs/el-salvador/validation/el-salvadorian-document';
import { validateElSalvadorianPhoneNumber } from '@tectonics/prs/el-salvador/validation/el-salvadorian-phone-number';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'elSalvadorDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_el_salvador_document') && validateElSalvadorianDocument(userInputValue);
      }
      return null;

    case 'elSalvadorPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_el_salvador_phone_number') && validateElSalvadorianPhoneNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
